module.exports = "<!-- Main view/routes wrapper-->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main